









































import type { DocumentPage } from '@getaccept/lib-shared/src/types/document-page';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed, ref } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import Field from '../fields/components/Field.vue';

export default defineComponent({
  components: {
    Field,
  },
  props: {
    page: {
      type: Object as PropType<DocumentPage>,
      default: null,
    },
    pageWidth: {
      type: Number,
      default: undefined,
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: undefined,
    },
    allRecipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      default: undefined,
    },
    focusedRequiredId: {
      type: String,
      default: '',
    },
    hideFields: {
      type: Boolean,
    },
    isPreview: {
      type: Boolean,
    },
    requiredStepsLeft: {
      type: Boolean,
    },
    isSigned: {
      type: Boolean,
    },
    initials: {
      type: String,
      default: '',
    },
    verifiedInitialFieldIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const imageIsLoaded = ref(false);
    const imageError = ref(false);

    const fields = computed(() => (props.page && props.page.fields) || []);

    const disableFields = computed(() => props.isPreview);

    const documentPageElementId = computed(() =>
      props.page ? `document-content-page-${props.page.id}` : 'document-content-page'
    );

    const skeletonHeight = computed(() =>
      props.page ? (props.pageWidth / props.page.pageWidth) * props.page.pageHeight : 900
    );

    const thumbUrl = computed(() => (props.page ? props.page.thumbUrl : ''));

    const showFields = computed(
      () => imageIsLoaded.value && !imageError.value && !props.hideFields
    );

    const imageDescription = (pageNumber: number) =>
      t('document-page', { 'page-number': pageNumber });

    const handleClickLinkField = (id: string) => {
      emit('clickLinkField', id);
    };

    const handleClickInitialsField = (id: string) => {
      emit('clickInitialsField', id);
    };

    const handleClickSignField = () => {
      emit('clickSignField');
    };

    const handleLoaded = () => {
      imageIsLoaded.value = true;
      imageError.value = false;
      emit('loaded');
    };

    const handleImgError = () => {
      imageError.value = true;
    };

    const handleUpdateField = ({ fieldId, value }: { fieldId: string; value: string }) => {
      emit('updateField', { fieldId, value });
    };

    return {
      t,
      imageIsLoaded,
      imageError,
      fields,
      disableFields,
      documentPageElementId,
      skeletonHeight,
      thumbUrl,
      showFields,
      imageDescription,
      handleClickLinkField,
      handleClickInitialsField,
      handleClickSignField,
      handleLoaded,
      handleImgError,
      handleUpdateField,
    };
  },
});
